import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { Icon } from '@99designs/common/components/Icon';
import { FormattedReactMessage } from '@99designs/common/i18n';
import { getSupportArticleUrl } from '@99designs/common/utils/platform/supportUrlHelpers';
import TrackedLink, { TrackedLinkProps } from './/TrackedLink';

export interface CircumventionWarningMessageProps extends InjectedIntlProps {
    event: TrackedLinkProps['event'];
}

function CircumventionWarningMessage({ intl, event }: CircumventionWarningMessageProps) {
    const { formatMessage } = intl;
    return (
        <div className="circumvention-warning" data-testid="circumvention-warning">
            <Icon type="exclamation-point-1" variations={['offset-right']} />
            <div>
                <FormattedReactMessage
                    message={formatMessage({
                        id: '<strong>Stay safe:</strong> always message and pay through 99designs. <TrackedLink>Read more</TrackedLink>.',
                    })}
                    replacements={{
                        strong: <strong />,
                        TrackedLink: (
                            <TrackedLink
                                event={event}
                                variations={['berlin-thing', 'no-wrap']}
                                href={getSupportArticleUrl(
                                    '360001346686',
                                    document.documentElement.lang
                                )}
                                children={'to be replaced by FormattedReactMessage'}
                            />
                        ),
                    }}
                />
            </div>
        </div>
    );
}
export default injectIntl(CircumventionWarningMessage);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarningMessage/CircumventionWarningMessage.tsx